import Button from "@app/components/button";
import TextGradient from "@app/components/gradient/gradient-text";
import { CONTACT_PAGE } from "@app/constants/routes";
import { useThemeContext } from "@app/contexts/theme-context";
import Image from "next/image";
import { useRouter } from "next/router";

export type Prop = {
  variant?: "light" | "dark";
};
const ConnectSection = ({ variant = "dark" }: Prop) => {
  const isLightVariant = variant === "light";
  const router = useRouter();
  const { isMobile } = useThemeContext();
  return (
    <div
      className={`px-4 pt-8 md:px-12 md:pt-12 lg:px-24 lg:pt-24 ${
        isLightVariant ? "" : "bg-background-primary-dark-dark"
      }  
      flex flex-col items-center justify-between md:gap-y-16`}
    >
      <div className="flex flex-col gap-y-5 items-center text-center max-w-[700px]">
        <TextGradient>
          <span className="h4 md:h3">
            {isLightVariant ? "Let's get connected!" : "Connect with us!"}
          </span>
        </TextGradient>
        <span
          className={`text-body-md lg:subheading ${
            isLightVariant ? "text-text-color-mid-em" : "text-light"
          }`}
        >
          {isLightVariant
            ? `If your company is looking for a strong partner within the waste and recycling industry, we'd like to hear from you.`
            : `If you're looking for a strong partner within the waste and recycling
          industry, we'd like to hear from you.`}
        </span>
        <div className="py-5 w-full md:w-auto">
          <Button
            buttonType="gradient"
            onClick={() => router.push(`/${CONTACT_PAGE}`)}
            full={isMobile}
            className={isMobile ? 'rounded-full' : ''}
          >
            {isLightVariant ? 'Connect with us!' : `Let's connect!`}
          </Button>
        </div>
      </div>
      <div className={`rounded-t-3xl border overflow-hidden border-4 xs:border-8 border-b-0 h-fit -mb-2 xs:-mb-4
        ${isLightVariant ? "border-black" : "border-white"}`}>
        <Image width={1216} height={428} src='/images/acquisitions/connect.png' alt="Join us" /> 
      </div>
    </div>
  );
};

export default ConnectSection;
